import { useEffect, useState } from 'react'

interface WindowSize {
  winWidth: number
  winHeight: number
}

function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    winWidth: 0,
    winHeight: 0,
  })

  useEffect(() => {
    const handler = () => {
      setWindowSize({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight,
      })
    }

    // Set size at the first client-side load
    handler()

    window.addEventListener('resize', handler)

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('resize', handler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return windowSize
}

export default useWindowSize 
